export default __webpack_public_path__ + "static/media/footer-menu-01.3aeac7ac.svg";